import styled from 'styled-components';

import { theme } from '../GlobalStyles';

import initialState from './initialState';

const INITIAL_LIMIT = 3;
const LOAD_MORE_LIMIT = 50;

const SearchQuery = styled.div`
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  font-size: 1.0625rem;
  padding: 0.8125rem 0;
  color: #4c8bff;
  margin-bottom: 1.875rem;
  ${theme.mediaQueries.above.small} {
    padding: 1.125rem 0;
  }
`;

const ResultSet = styled.div`
  .heading {
    display: flex;
    justify-content: space-between;
    strong {
      font-size: 0.8125rem;
      text-transform: uppercase;
      color: ${theme.colors.black};
    }
  }
  ul {
    padding: 0;
  }
  ul,
  li {
    list-style: none;
  }
  .view-all {
    font-size: 1rem;
    cursor: pointer;
  }
`;

const searchReducer = (state, action) => {
  switch (action.type) {
    case 'SET_RESULTS': {
      const { type, results } = action.payload;
      const output = type
        ? {
            results: results.filter((result) => result.viewType === type),
            limit: LOAD_MORE_LIMIT,
          }
        : {
            results,
            limit: INITIAL_LIMIT,
          };

      return {
        ...state,
        status: 'complete',
        detail: { type, page: type ? 1 : null },
        ...output,
      };
    }
    case 'MORE_RESULTS': {
      const { type, page, limit } = action.payload;
      return {
        ...state,
        status: 'complete',
        detail: { type, page },
        limit,
      };
    }
    case 'LOADING':
      return {
        ...state,
        status: 'loading',
      };
    case 'SET_ERROR':
      return {
        ...state,
        error: action.value,
      };
    default:
      return state;
  }
};

export { searchReducer, SearchQuery, ResultSet, INITIAL_LIMIT, LOAD_MORE_LIMIT, initialState };
